import { ThemeProvider } from '@mui/material/styles';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

import MainApp from './MainApp';
import { theme } from './theme';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './app/store';
import AppUpdate from './AppUpdate';
import ClasspepLoader from './components/common/ClasspepLoader';
import { useEffect } from 'react';

export default function App() {
  useEffect(() => {
    const init = async () => {
      if (!Capacitor.isNativePlatform()) return;

      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#2F527A' });
    };
  
    init();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={<ClasspepLoader />} persistor={persistor}>
          <AppUpdate>
            <MainApp />
          </AppUpdate>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}
